<template>
<v-container>
  
  
  <v-dialog
    v-model="loading"
    hide-overlay
    persistent
    width="300"
    >
    <v-card
      color="red"
      dark
      >
      <v-card-text>
        Please stand by
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
          ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
  
  <div v-if="reports.reports.length > 0">
    
    <v-card v-for="report in reports.reports" :key="report.name">
      <v-card-title>{{ report.name }}</v-card-title>
      <v-card-text>

        <v-btn text small color="error" @click="datasetHideAll(report.graphData)">Hide all</v-btn>
	<v-btn text small color="success" @click="datasetShowAll(report.graphData)">Show all</v-btn>
	
	<LineChart
	  ref="graph"
	  :options="graphOptions"
	  :chart-data="report.graphData"
	  :height="graphHeight"
	  ></LineChart>
	
      </v-card-text>
    </v-card>
  </div>
  
  
  
</v-container>
</template>

<script>
import LineChart from './LineChart.js'

import { config } from '../config';


export default {
    components: {
	LineChart,
    },
    
    props: {
	wantedreportdate: String
    },
    
    data: () => ({
        loading: true,
	errorState: false,
	booltrue: true,
	reports: [],
	graphOptions: {
	    responsive: true,
	    maintainAspectRatio: true,
	},
	graphData: {},
	graphHeight: 200,
	colors: [
	    '#EF5350',
	    '#7E57C2',
	    '#42A5F5',
	    '#26A69A',
	    '#66BB6A',
	    '#FFEE58',
	],
    }),
    
    created() {
	this.loadData();
    },
    
    watch: {
	wantedreportdate() {
	    this.loadData();
	},
    },
    
    computed: {
    },
    
    methods: {
	getColor() {
	    return this.colors[Math.floor((Math.random() * this.colors.length) + 0)];
	},
	
	loadData() {
	    this.loading = true;
            const url = `${config.baseUrl}deliveries/history?date=${this.wantedreportdate}`;
	    
            this.$http.get(url, { auth: this.$store.getters.auth }).then((res) => {
		this.reports = [];
		let _reports = res.data;
		//_reports.reports = _reports.reports.slice(1, 3);
                this.loading = false;
	
		
		_reports.reports.forEach(r => {
		    let _graphData = {
	    		labels: _reports.dates,
	    		datasets: [],
		    };
		    
		    r.graphData = _graphData;
		    
		    r.products.forEach(rp => {
			
			r.graphData.datasets.push({
		    	    label: rp.name,
	    	    	    borderColor: this.getColor(),
		    	    lineTension: 0,
	    	    	    data: rp.reports.map(rpr => rpr.available_files),
			});
			
		    });
		});
		
		this.reports = _reports;
            }).catch((err) => {
                console.log(err);
            });
	},

	datasetHideAll(graph) {
	    this.$refs.graph.forEach(g => {
		g.refresh();
	    });
	    graph.datasets.forEach(ds => {
		ds.hidden = true;
		
	    });
	},
	
	datasetShowAll(graph) {
	    this.$refs.graph.forEach(g => {
		g.refresh();
	    });
	    graph.datasets.forEach(ds => {
		ds.hidden = false;
	    });
	},
    },
};
</script>

<style lang="scss" scoped>
canvas {
    background-color: red;
    height: 100px !important;
}
</style>
